import {
  AppEnv,
  IAppConfig,
  PiTargetBg,
} from '../../config/appConfig/appConfig.types';

// Default data for init of context
const appConfigDefault: IAppConfig = {
  isProd: false,
  isTrueProd: false,
  isMock: false,
  isLocal: false,

  app: {
    shortName: '',
    displayName: '',
    env: AppEnv.Mock,
    version: '',
  },

  api: {
    useDirectHost: false,
    auth: '',
    graphql: '',
    restEndpoint: '',
    piHost: '',
  },

  analytics: {
    quantum: {
      enabled: false,
      devEndpoint: '',
      prodEndpoint: '',

      config: {
        domain: '',
        appName: '',
        appVersion: '',
        packageVersion: '',
        appEnvName: '',
        startSession: '',
        requirementsVersion: '',
      },
    },

    adobe: {
      enabled: false,
      devEndpoint: '',
      prodEndpoint: '',
    },
  },

  auth: {
    targetBg: PiTargetBg.Default,
    loginUrl: '',
    loginParams: '',
    logoutUrl: '',
    piClientId: '',
    autoLogout: {
      timeoutMins: 55,
      preTimeoutWarnMins: 5,
    },
  },

  tdcs: {
    enabled: false,
    apiKey: '',
    host: '',
    config: {
      appVersion: '',
      clientType: '',
      deviceId: '',
      osVersion: '',
      deviceType: '',
    },
    localConfig: '', // for local development only
  },

  // Access Google API library
  google: {
    siteKey: '',
  },
  datadog: {
    host: 'https://charter-blue.datadoghq.com',
    applicationId: '810d8583-3e10-466b-92e9-a7992edba8fa',
    env: 'mock',
  },
};

export default appConfigDefault;
